<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/Master/ManageShopSubAgent'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit" ref="searchForm">
            <div class="row">
              <div class="col-xl-8 col-lg-8 col-md-8 .col-sm-8 col-xs-8">
                <div class="form-group">
                  <label>คำค้นหา:</label>
                  <input
                    v-model="sumKeyword"
                    type="text"
                    class="form-control"
                    placeholder="ค้นหาจากชื่อร้านค้า ชื่อร้านค้า 2 ชื่อผู้ติดต่อ เจ้าหน้าที่ดูแล โดยสามารถคั่นระหว่างคำได้ด้วยเครื่องหมายลูกน้ำ เช่น ชื่อร้านค้า 1, ชื่อร้านค้า 2"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'sumInActiveStatus'"
                    :name="'sumInActiveStatus'"
                    :select2-options="sumInActiveStatusOptions"
                    v-model="sumInActiveStatus"
                    ref="sumInActiveStatusSelect2"
                  ></select2>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทร้านค้า:</label>
                  <treeselect
                    v-model="sumShopTypeId"
                    :multiple="true"
                    :options="sumShopTypeIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>สถานะประเภทร้านค้า:</label>
                  <treeselect
                    v-model="shmShopGroupId"
                    :multiple="true"
                    :options="shmShopGroupIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>จังหวัด:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'sumProvinceId'"
                    :name="'sumProvinceId'"
                    :select2-options="sumProvinceIdOptions"
                    @selectChange="onAmpherIdChange"
                    v-model="sumProvinceId"
                    ref="sumProvinceIdSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>อำเภอ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'sumAmpherId'"
                    :name="'sumAmpherId'"
                    :select2-options="sumAmpherIdOptions"
                    v-model="sumAmpherId"
                    ref="sumAmpherIdSelect2"
                  ></select2>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ตัวแทนจำหน่ายย่อย :</label>
                  <!-- <select
                    id="agentList_agentKey"
                    name="agentList_agentKey"
                    class="form-control m-select2"
                    style="width: 100%;"
                    multiple="multiple"
                  ></select> -->
                  <treeselect
                    id="sumSubShopAgent"
                    v-model="sumSubShopAgent"
                    :async="true"
                    :multiple="true"
                    :load-options="LoadSumSubShopAgentOptions"
                    v-on:open="reLoadSumSubShopAgentOptions"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="false"
                    ref="sumSubShopAgent"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">ค้นหา</button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button
                  class="btn btn-outline-primary"
                  @click="exportShopSubAgent"
                  type="submit"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
                <router-link
                  to="ManageShopSubAgent/Add"
                  tag="button"
                  title="เพิ่ม"
                  class="btn btn-outline-brand"
                  v-if="
                    this.$root.canShow([
                      'MANAGE_MASTER',
                      'MANAGE_SHOP_SUB_AGENT',
                    ])
                  "
                >
                  <i class="fa fa-plus-circle"></i> เพิ่ม
                </router-link>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="subAgentTable"
              >
                <thead>
                  <tr>
                    <th></th>
                    <th class="all">รหัสร้านค้า</th>
                    <th class="all">ชื่อร้านค้า</th>
                    <th class="all">ชื่อร้านค้า 2</th>
                    <th class="all">ประเภทร้านค้า</th>
                    <th class="all">สถานะประเภทร้านค้า</th>
                    <th class="all">ผู้ดูแลร้านค้า</th>
                    <th class="all">ผู้ดูแลร้านค้า 2</th>
                    <th class="none">ที่อยู่</th>
                    <th class="none">อีเมล</th>
                    <th class="all">เบอร์โทร</th>
                    <th class="all">ชื่อผู้ติดต่อ</th>
                    <th class="none">เจ้าหน้าที่ดูแล (ตัวแทน)</th>
                    <th class="none">เจ้าหน้าที่ดูแล (boonrawd)</th>
                    <th class="all">อำเภอ</th>
                    <th class="all">จังหวัด</th>
                    <th class="none">Latitude</th>
                    <th class="none">Longitude</th>
                    <th class="all">สถานะ</th>
                    <th class="all">การจัดการ</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../../router";
import select2 from "../../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
// import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import DatatableWarning from "../../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

let StatusActionsTrue = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-success">
      <i class="fas fa-play"></i>เปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      var table = $("#subAgentTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่...",
          });

          axios
            .put("/Api/SubAgent/" + this.data.subAgentId + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});
let StatusActionsFalse = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-danger">
      <i class="fas fa-pause"></i>ปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      var table = $("#subAgentTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่...",
          });

          axios
            .put("/Api/SubAgent/" + this.data.subAgentId + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});
let Action = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="edit" v-if="data.showEditButton" title="แก้ไข" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-edit"></i>
    </a>
  </div>`,
  methods: {
    edit: function() {
      router.push({
        path: `/Master/ManageShopSubAgent/Edit/${this.data.subAgentId}`,
      });
    },
  },
});

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      sumKeyword: null,
      sumInActiveStatus: null,
      sumShopTypeId: [],
      shmShopGroupId: [],
      sumProvinceId: null,
      sumAmpherId: null,
      sumSubShopAgent: [],
      sumSubShopAgentOptions: [],
      //config
      sumInActiveStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "false", text: "ใช้งาน", data: null },
          { id: "true", text: "ปิดใช้งาน", data: null },
        ],
      },
      sumSubAgentOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "true", text: "ใช่", data: null },
          { id: "false", text: "ไม่ใช่", data: null },
        ],
      },
      sumShopTypeIdOptions: [],
      sumProvinceIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchProvince",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      shmShopGroupIdOptions: [],
      sumAmpherIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchAmpher",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              provinceId: self.sumProvinceId,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    formReset: function(e) {
      this.sumKeyword = "";
      this.sumShopTypeId = [];
      this.shmShopGroupId = [];
      this.sumSubShopAgent = [];
      //default Active Data
      this.sumInActiveStatus = false;
      $("#sumInActiveStatus")
        .val(this.sumInActiveStatus + "")
        .trigger("change");

      $("#sumShopTypeId")
        .val("")
        .trigger("change");

      $("#shmShopGroupId")
        .val("")
        .trigger("change");

      $("#sumProvinceId")
        .val("")
        .trigger("change");

      $("#sumAmpherId")
        .val("")
        .trigger("change");

      $("#sumSubShopAgent")
        .val("")
        .trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#subAgentTable").DataTable();
      table.search(this.id | this.name);
      table.column(4).search(this.status != "-1" ? this.status : "");
      table.draw();
    },
    exportShopSubAgent: function(e) {
      e.preventDefault();
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportShopSubAgent",
        responseType: "arraybuffer",
        data: {
              SearchKeyword: self.sumKeyword,
              ShopTypeId: self.sumShopTypeId,
              ShopGroupId: self.shmShopGroupId,
              ProvinceId: self.sumProvinceId,
              AmpherId: self.sumAmpherId,
              InActiveStatus: self.sumInActiveStatus,
              SubAgentCode: self.sumSubShopAgent
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            var fname = filename.split("RPT_")[1] ;  
            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            // link.download = "ข้อมูลร้านค้า" + filename;
            link.download = "จัดการข้อมูลร้านค้าตัวแทนจำหน่ายย่อย_" + fname //+ filename;
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    reloadDataTable: function(resetPaging = false) {
      $("#subAgentTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
    onAmpherIdChange: function() {
      $("#sumAmpherId")
        .val("")
        .trigger("change");
    },
    LoadShopTypeIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ShopType/Select2SearchShopType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.sumShopTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadSumSubShopAgentOptions: function({ searchQuery, callback }) {
      var self = this;
      self.sumSubShopAgentOptions = []
        axios
          .post("/Api/SubAgent/Select2SearchSubAgent", {
            page: 1,
            all: true,
            search: searchQuery,
            //subShopAgent: sumSubShopAgent,
          })
          .then(function(response) {
            if (response.status == 200) {
              self.sumSubShopAgentOptions = [];
              var data = response.data.results;
              data.forEach((element) => {
                self.sumSubShopAgentOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
              callback(null, self.sumSubShopAgentOptions);
          })
          .catch(function(error) {});
    },
    // 1000),
    reLoadSumSubShopAgentOptions: function(){
      this.$refs.sumSubShopAgent.trigger.searchQuery = null;
    },
    LoadShopGroupIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ShopType/Select2SearchShopGroup", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.shmShopGroupIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
  },
  async mounted() {
    let self = this;
    self.LoadShopTypeIdOptions();
    self.LoadShopGroupIdOptions();
    //self.LoadSumSubShopAgentIdOptions();
    //default Active Data
    self.sumInActiveStatus = false;
    $("#sumInActiveStatus")
      .val(self.sumInActiveStatus + "")
      .trigger("change");

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#subAgentTable");
    // begin first table
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/SubAgent/Search",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            //console.log(d);
            return JSON.stringify(
              $.extend(d, {
                SearchKeyword: self.sumKeyword,
                ShopTypeId: self.sumShopTypeId,
                ShopGroupId: self.shmShopGroupId,
                ProvinceId: self.sumProvinceId,
                AmpherId: self.sumAmpherId,
                InActiveStatus: self.sumInActiveStatus,
                SubAgentCode: self.sumSubShopAgent
              })
            );
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },

        // Order settings
        order: [[1, "desc"]],
        columns: [
          {
            data: null,
            className: "details-control",
            defaultContent: "",
            orderable: false,
          },
          { 
            data: "subAgentId", 
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.subAgentCode
            },
          },
          { data: "subAgentName", className: "text-center" },
          { data: "subAgentName2", className: "text-center" },
          { data: "shopTypeName", className: "text-center" },
          { data: "shopGroupName", className: "text-center" },
          { data: "shopName", className: "text-center" },
          { data: "shopName2", className: "text-center" },
          { data: "address", className: "text-center" },
          { data: "email", className: "text-center" },
          { data: "tel", className: "text-center" },
          { data: "fullName", className: "text-center" },
          { data: "contactShopFullName", className: "text-center" },
          { data: "employeeFullName", className: "text-center" },
          { data: "ampherName", className: "text-center", orderable: false },
          { data: "provinceName", className: "text-center", orderable: false },
          { data: "latitude", className: "text-center" },
          { data: "longitude", className: "text-center" },
          {
            data: "inActiveStatus",
            className: "text-center",
            width: "10%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actionsStatus"></div>';
            },
          },
          {
            data: "customerCode",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            },
          },
        ],
      })
      .on("preXhr.dt", function() {
        KTApp.block(self.$refs.searchForm, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("xhr.dt", function() {
        KTApp.unblock(self.$refs.searchForm);
      })
      .on("draw.dt", function() {
        $(".actionsStatus").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditStatusButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MANAGE_SHOP_SUB_AGENT",
            ]);
            if (data.inActiveStatus == 0)
              new StatusActionsTrue({ data: { data }, parent: self }).$mount(
                el
              );
            else if (data.inActiveStatus == 1)
              new StatusActionsFalse({ data: { data }, parent: self }).$mount(
                el
              );
          }
        });
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          //console.log(data);
          if (data) {
            data.showEditButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MANAGE_SHOP_SUB_AGENT",
            ]);
            // data.showDeleteButton = self.$root.canShow([
            //   "MANAGE_MASTER",
            //   "MANAGE_SHOP_SUB_AGENT"
            // ]);
            new Action({ data: { data }, parent: self }).$mount(el);
          }
        });
      });
    //table.trigger("draw.dt"); //call ajax delete this row
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Master/ShopSupAgent/ManageShopSubAgent.vue